class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    var lists = document.querySelectorAll('.facets__list')

    const detailss = document.querySelectorAll('facet-filters-form.small-hide details')
    detailss.forEach((detail) => {
      detail.addEventListener('click', () => {
        if (detail.hasAttribute('open')) {
          // detailss.forEach((detaill) => {detaill.removeAttribute('open')})
        } else {
          detailss.forEach((detaill) => {detaill.removeAttribute('open')})
          // detail.addAttribute('open')
          const detail_div = detail.querySelector('.facets__display')
        }
      })

    });

    $('html').click(function() {
      const detailss = document.querySelectorAll('facet-filters-form.small-hide details[open]')
      detailss.forEach((detail) => {
        detail.removeAttribute('open')
      })
    });

    $('.facets__display').click(function(event){
         event.stopPropagation();
    });



  }

  static setListeners() {
    const onHistoryChange = (event) => {

      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {

    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        console.log('fetch')
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

      });

  }

  static renderSectionFromCache(filterDataUrl, event) {
    console.log('from cache')
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    document.querySelectorAll('price-range').forEach( (pr) => pr.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('price-range').innerHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {

    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
    var slider_price = function() {

      $(document).ready(function() {
        $('.price-range-slider').each(function(e) {

            var slider = $(this),
                width = slider.width(),
                handle,
                handleObj;

            let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', '0 0 ' + width + ' 83');

            slider.html(svg);
            slider.append($('<div>').addClass('active').html(svg.cloneNode(true)));

            if ($("#Filter-Price-LTE").val() == '') {
              var max = parseInt($("#Filter-Price-LTE").attr('max'))
            } else {
              var max = parseInt($("#Filter-Price-LTE").val())
            }
            if (parseInt($("#Filter-Price-GTE").val() == '')) {
              var min = parseInt($("#Filter-Price-GTE").attr('min'))
            } else {
              var min = parseInt($("#Filter-Price-GTE").val())
            }
            slider.slider({
                range: true,
                values: [ min, max],
                min: 0,
                step: 5,
                max: $("#Filter-Price-LTE").attr('max'),
                create(event, ui) {
                    slider.find('.ui-slider-handle').append($('<div />'));

                    $(slider.data('value-0')).val(slider.slider('values', 0));
                    $("#Mobile-"+slider.data('value-0')).val(slider.slider('values', 0));

                    $(".first").html(slider.slider('values', 0));

                    $(slider.data('value-1')).val(slider.slider('values', 1));
                    $("#Mobile-"+slider.data('value-1')).val(slider.slider('values', 1));

                    $(".last").html(slider.slider('values', 1));

                    $(slider.data('range')).html((slider.slider('values', 1) - slider.slider('values', 0)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '&thinsp;'));

                    setCSSVars(slider);

                },
                start(event, ui) {

                    $('body').addClass('ui-slider-active');

                    handle = $(ui.handle).data('index', ui.handleIndex);
                    handleObj = slider.find('.ui-slider-handle');

                },
                change(event, ui) {
                    setCSSVars(slider);
                    const detailss = document.querySelectorAll('facet-filters-form.small-hide details[open]')
                    detailss.forEach((detail) => {
                      detail.removeAttribute('open')
                    })

                    let min = slider.slider('option', 'min'),
                        minRange = slider.slider('option', 'minRange'),
                        max = slider.slider('option', 'max');

                    if(ui.handleIndex == 0) {
                        if((ui.values[0] + minRange) >= ui.values[1]) {
                            slider.slider('values', 1, ui.values[0] + minRange);
                        }
                        if(ui.values[0] > max - minRange) {
                            return false;
                        }
                    } else if(ui.handleIndex == 1) {
                        if((ui.values[1] - minRange) <= ui.values[0]) {
                            slider.slider('values', 0, ui.values[1] - minRange);
                        }
                        if(ui.values[1] < min + minRange) {
                            return false;
                        }
                    }

                    $(slider.data('value-0')).val(ui.values[0]).on('input');
                    $("#Mobile-Filter-Price-GTE").val(ui.values[0]).on('input');


                    $(".first").html(ui.values[0]);

                    $(slider.data('value-1')).val(ui.values[1]).change();
                    $("#Mobile-Filter-Price-LTE").val(ui.values[1]).on('input');

                    $(".last").html(ui.values[1]);

                    $(slider.data('range')).html((slider.slider('values', 1) - slider.slider('values', 0)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '&thinsp;'));

                    setCSSVars(slider);

                    const formData = new FormData(event.target.closest('form'));
                    const searchParams = new URLSearchParams(formData).toString();

                    FacetFiltersForm.renderPage(searchParams, event);

                },
                slide(event, ui) {
                  let min = slider.slider('option', 'min'),
                      minRange = slider.slider('option', 'minRange'),
                      max = slider.slider('option', 'max');

                  if(ui.handleIndex == 0) {
                      if((ui.values[0] + minRange) >= ui.values[1]) {
                          slider.slider('values', 1, ui.values[0] + minRange);
                      }
                      if(ui.values[0] > max - minRange) {
                          return false;
                      }
                  } else if(ui.handleIndex == 1) {
                      if((ui.values[1] - minRange) <= ui.values[0]) {
                          slider.slider('values', 0, ui.values[1] - minRange);
                      }
                      if(ui.values[1] < min + minRange) {
                          return false;
                      }
                  }

                  $(slider.data('value-0')).val(ui.values[0]).on('input');
                  $("#Mobile-Filter-Price-GTE").val(ui.values[0]).on('input');


                  $(".first").html(ui.values[0]);

                  $(slider.data('value-1')).val(ui.values[1]).change();
                  $("#Mobile-Filter-Price-LTE").val(ui.values[1]).on('input');

                  $(".last").html(ui.values[1]);

                  $(slider.data('range')).html((slider.slider('values', 1) - slider.slider('values', 0)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '&thinsp;'));

                  setCSSVars(slider);


                },
                stop(event, ui) {

                    $('body').removeClass('ui-slider-active');

                    let duration = .6,
                        ease = Elastic.easeOut.config(1.08, .44);

                    TweenMax.to(handle, duration, {
                        '--y': 0,
                        ease: ease
                    });

                    TweenMax.to(svgPath, duration, {
                        y: 42,
                        ease: ease
                    });

                    handle = null;

                }
            });

            var svgPath = new Proxy({
                x: null,
                y: null,
                b: null,
                a: null
            }, {
                set(target, key, value) {
                    target[key] = value;
                    if(target.x !== null && target.y !== null && target.b !== null && target.a !== null) {
                        slider.find('svg').html(getPath([target.x, target.y], target.b, target.a, width));
                    }
                    return true;
                },
                get(target, key) {
                    return target[key];
                }
            });

            svgPath.x = width / 2;
            svgPath.y = 42;
            svgPath.b = 0;
            svgPath.a = width;

            $(document).on('mousemove touchmove', e => {
                if(handle) {

                    let laziness = 4,
                        max = 24,
                        edge = 52,
                        other = handleObj.eq(handle.data('index') == 0 ? 1 : 0),
                        currentLeft = handle.position().left,
                        otherLeft = other.position().left,
                        handleWidth = handle.outerWidth(),
                        handleHalf = handleWidth / 2,
                        y = e.pageY - handle.offset().top - handle.outerHeight() / 2,
                        moveY = (y - laziness >= 0) ? y - laziness : (y + laziness <= 0) ? y + laziness : 0,
                        modify = 1;

                    moveY = (moveY > max) ? max : (moveY < -max) ? -max : moveY;
                    modify = handle.data('index') == 0 ? ((currentLeft + handleHalf <= edge ? (currentLeft + handleHalf) / edge : 1) * (otherLeft - currentLeft - handleWidth <= edge ? (otherLeft - currentLeft - handleWidth) / edge : 1)) : ((currentLeft - (otherLeft + handleHalf * 2) <= edge ? (currentLeft - (otherLeft + handleWidth)) / edge : 1) * (slider.outerWidth() - (currentLeft + handleHalf) <= edge ? (slider.outerWidth() - (currentLeft + handleHalf)) / edge : 1));
                    modify = modify > 1 ? 1 : modify < 0 ? 0 : modify;

                    if(handle.data('index') == 0) {
                        svgPath.b = currentLeft / 2  * modify;
                        svgPath.a = otherLeft;
                    } else {
                        svgPath.b = otherLeft + handleHalf;
                        svgPath.a = (slider.outerWidth() - currentLeft) / 2 + currentLeft + handleHalf + ((slider.outerWidth() - currentLeft) / 2) * (1 - modify);
                    }

                    svgPath.x = currentLeft + handleHalf;
                    svgPath.y = moveY * modify + 42;

                    handle.css('--y', moveY * modify);

                }
            });

        });

        function getPoint(point, i, a, smoothing) {
            let cp = (current, previous, next, reverse) => {
                    let p = previous || current,
                        n = next || current,
                        o = {
                            length: Math.sqrt(Math.pow(n[0] - p[0], 2) + Math.pow(n[1] - p[1], 2)),
                            angle: Math.atan2(n[1] - p[1], n[0] - p[0])
                        },
                        angle = o.angle + (reverse ? Math.PI : 0),
                        length = o.length * smoothing;
                    return [current[0] + Math.cos(angle) * length, current[1] + Math.sin(angle) * length];
                },
                cps = cp(a[i - 1], a[i - 2], point, false),
                cpe = cp(point, a[i - 1], a[i + 1], true);
            return `C ${cps[0]},${cps[1]} ${cpe[0]},${cpe[1]} ${point[0]},${point[1]}`;
        }

        function getPath(update, before, after, width) {
            let smoothing = .16,
                points = [
                    [0, 42],
                    [before <= 0 ? 0 : before, 42],
                    update,
                    [after >= width ? width : after, 42],
                    [width, 42]
                ],
                d = points.reduce((acc, point, i, a) => i === 0 ? `M ${point[0]},${point[1]}` : `${acc} ${getPoint(point, i, a, smoothing)}`, '');
            return `<path d="${d}" />`;
        }

        function setCSSVars(slider) {
            let handle = slider.find('.ui-slider-handle');
            slider.css({
                '--l': handle.eq(0).position().left + handle.eq(0).outerWidth() / 2,
                '--r': slider.outerWidth() - (handle.eq(1).position().left + handle.eq(1).outerWidth() / 2)
            });
        }
      })
    }
    slider_price()
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {

    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);

  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}



FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

customElements.define('facet-remove', FacetRemove);
